declare module Handlebars {
    export function compile(markup: any): any;
}

type LoadMoreContext = {
    Type: string;
    ForType: string;
    ForValue: string;
    Total: number;
    Shown: number;
    PageSize: number;
}

type LoadMoreAttributeNames = {
    [K in keyof LoadMoreContext]: string;
}

interface ILoadMoreContentResponse {
    results: any[];
    totalCount: number;
}

namespace KWS.controllers.loadMore {

    const EVENT_SELECTOR = "[data-loadmore]";

    const DATA_ATTR_NAME: LoadMoreAttributeNames = {
        Type: "loadmore-type",
        ForType: "loadmore-fortype",
        ForValue: "loadmore-forvalue",
        Total: "loadmore-total",
        Shown: "loadmore-shown",
        PageSize: "loadmore-pagesize"
    };

    function toggleClickEvent(enable: boolean): void {
        if (enable) $(document).on('click', EVENT_SELECTOR, handleClickEvent);
        else $(document).off('click', EVENT_SELECTOR, handleClickEvent);
    }

    function handleClickEvent(e: JQueryEventObject): void {
        // Stop the browser from handling click
        e.preventDefault();
        e.stopPropagation();

        // Clicked element containing context attributes
        let $element = $(e.target);

        // Parse context from element attributes
        let context = parseContext($element);

        // Fetch more content
        fetchContent(context).done(content => {
            // Render fetched content
            renderContent(context, content);

            // Update context
            updateContext(context, content);

            // Write context to element attributes
            persistContext(context, $element);

            // Unregister and hide click element if all content has loaded
            disableIfAllContentHasLoaded(context, $element);
        });
    }

    function parseContext($element: JQuery): LoadMoreContext {
        return {
            Type: $element.data(DATA_ATTR_NAME.Type),
            ForType: $element.data(DATA_ATTR_NAME.ForType),
            ForValue: $element.data(DATA_ATTR_NAME.ForValue),
            Total: $element.data(DATA_ATTR_NAME.Total),
            Shown: $element.data(DATA_ATTR_NAME.Shown),
            PageSize: $element.data(DATA_ATTR_NAME.PageSize),
        };
    }

    function updateContext(context: LoadMoreContext, content: ILoadMoreContentResponse): void {
        context.Shown += content.results.length;
        context.Total = content.totalCount;
    }

    function persistContext(context: LoadMoreContext, $element: JQuery): void {
        $element
            .data(DATA_ATTR_NAME.Total, context.Total)
            .attr(`data-${DATA_ATTR_NAME.Total}`, context.Total);
        $element
            .data(DATA_ATTR_NAME.Shown, context.Shown)
            .attr(`data-${DATA_ATTR_NAME.Shown}`, context.Shown);
    }

    function fetchContent(context: LoadMoreContext): JQueryPromise<ILoadMoreContentResponse> {
        const deferred = $.Deferred();
        const settings: JQueryAjaxSettings = {
            async: true,
            url: `/api/kws/support/${context.ForType}/${context.ForValue}/${context.Type}?skip=${context.Shown}&take=${context.PageSize}`,
            method: "GET",
            headers: {
                accept: "application/json"
            }
        };
        $.ajax(settings)
            .done(deferred.resolve)
            .fail(deferred.reject);
        return deferred.promise();
    }

    function renderContent(context: LoadMoreContext, content: ILoadMoreContentResponse) {
        const template = document.getElementById(`${context.Type}-template`).innerHTML;
        const compile = Handlebars.compile(template);
        const markup = compile(content);
        $(`.loadmore-${context.Type}`).append(markup);
    }

    function disableIfAllContentHasLoaded(context: LoadMoreContext, $element: JQuery) {
        if (context.Shown >= context.Total) {
            toggleClickEvent(false);
            $element.hide();
        }
    }

    export function init() {
        toggleClickEvent(true);
    }
}

KWS.controllers.loadMore.init();